export class Communicator {
    protected routes: { [key: string]: string[] } = {
        'products': [
            'hg',
            'ug',
            'tg',
            'ar',
            'nw',
            'd1',
            'd1inch',
            'mat',
            'sp',
            'textfilter'
        ],
        'search': [
            's',
            'adv',
            'd1',
            'd1inch',
            'nw',
            'm',
            'sp',
            'ug'
        ],
        'login': [],
        'logout': [],
        'register': [],
        'recover': [],
        'password': [
            'userId',
            'guid',
        ],
        'activation': [
            'userId',
            'guid',
        ],
        'page': [
            'id'
        ],
    };

    constructor() {
        window.addEventListener("load", this.sendHeight.bind(this));
        window.addEventListener("resize", this.sendHeight.bind(this));    
        window.addEventListener("message", this.handleMessage.bind(this));
        window.addEventListener("beforeunload", () => {
            this.sendNavigateStart();
        });

        setTimeout(this.sendHeight.bind(this), 5000); //fire height message after 5 seconds, for the case when the page is loaded before the parent frame
        
        const observer = new MutationObserver((mutations) => {
            this.sendHeight();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: false
        });

    }

    handleMessage(event: MessageEvent) {
        if (event.data.type === "scroll") {
            const top = parseInt( event.data.payload );
            if (Number.isNaN( top )) {
                document.body.style.removeProperty("--scroll-top");
            } else {
                document.body.style.setProperty("--scroll-top", -top + "px");
            }
        }
    }
    
    sendHeight() {
        this.send("resize", document.body.scrollHeight);
    }

    sendNavigateStart() {
        this.send("navigateStart", {});
    }

    sendNavigate(url: string = window.location.pathname) {
        const match = url.match(/^\/frame\/([a-z_-]+)\.php$/);

        if (match && Array.isArray(match)) {
            const action = match[1];
            if ( Object.keys(this.routes).includes(action) ) {
                const params = new URL(window.location.href).searchParams;
                const payload: any = {
                    action: action
                };

                if (this.routes[action].length > 0) {
                    this.routes[action].forEach((key) => {
                        payload[key] = params.get(key);
                    });
                }
                
                this.send("navigate", payload);
            }
        }
    };

    waitForReady(): Promise<void> {
        return new Promise<void>((resolve) => {
            const interval = window.setInterval(() => {
                this.send("ready", {});
            }, 100);

            const handler = (event: MessageEvent) => {
                if (event.data?.type === 'ready') {
                    clearInterval(interval);
                    window.removeEventListener('message', handler);
                    resolve();
                }
            };

            window.addEventListener('message', handler);
        });
    }

    send(type: string, payload: any) {
        const message = {
            type: type,
            payload: payload
        };
    
        window.parent.postMessage(message, "*");
    } 
}
